import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { GlobalPriceChart } from "./global-price-chart.entity";

@Entity('global_price_chart_log')
export class GlobalPriceChartLog {
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column('date',{
        name:'effective_from',
        nullable: false
    })
    effectiveFrom: Date

    @Column('decimal',{
        name:'old_price',
        precision:10,
        scale:2,
        nullable:false
    })
    oldPrice: number

    @CreateDateColumn({
        name:'created_at',
        type:'datetime'
    })
    createdAt: Date

    @Column('varchar',{
        name:'created_user',
        nullable: true
    })
    createdUser: string | null

    @ManyToOne(type=>GlobalPriceChart,gpc=>gpc.gpclInfo,{nullable:false})
    @JoinColumn({name:'global_price_chart_id'})
    gpcInfo: GlobalPriceChart
}